"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterTransformDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var filterTransformDependencies = exports.filterTransformDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createFilterTransform: _factoriesAny.createFilterTransform
};